import React from 'react';

const CustomColumn = ({
  alignItems = 'flex-start',
  color = 'inherit',
  height = 'auto',
  justifyContent = 'flex-start',
  margin = '0',
  minWidth = 'auto',
  padding = '0',
  width = 'auto',
  children
}) => {
  return (
    <div
      style={{
        alignItems,
        color,
        display: 'flex',
        flexDirection: 'column',
        height,
        justifyContent,
        margin,
        minWidth,
        padding,
        width
      }}
    >
      {children}
    </div>
  );
};

export default CustomColumn;
